import gql from 'graphql-tag';

export const GetSRASectionQuestions = (sectionName) => (gql`query GetSRAQuestions {
  getSRASectionQuestions(sectionName:"${sectionName}") {
    questions
    next {
      section
      sectionName
    }
    prev {
      section
      sectionName
    }
  
  }
}`
);

export const GetSRASections = () => (gql`query GetSRASections {
  getSRASectionNames{
    sections {
      section
      sectionName
      progress,
      riskScore
    }   
    overallRisk {
      risk
      riskScore
    }
    
  }
}`
);

export const GetHIPAAAssessmentData = () => (gql`query getHIPAAComplianceAssessment{
  getHIPAAComplianceAssessment{
    assessmentData
  }
}`
);

export const GetComplianceAssessmentV2 = () => (gql `query GetComplianceAssessmentV2($assessmentType: String!) {
  complianceAssessmentV2(assessmentType: $assessmentType) {
    assessmentName
    level
    score
  }
}
` );

export const GetComplianceAssessmentData = () => (gql `query GetComplianceAssessmentData{
  complianceAssessment{
    question
    response
  }
}`
);

export const SubmitSRASectionAnswer = () => {
  return gql`mutation submitSRASectionAnswer($answers:SRASectionAnswersInput){
    submitSRASectionAnswers(input:$answers){
      sectionRisk{
        riskScore
        progress
      }
      overallRisk {
        risk
        riskScore
        progress
      }
    }
  }`
}

export const GetAllAssessments = () => {
  return gql`query GetAllAssessments {
    cmmc:complianceAssessmentV2(assessmentType: "cmmc") {
      assessmentName
      level
      score
    }
    hipaa:complianceAssessmentV2(assessmentType:"hipaa"){
      assessmentName
      score
    }
    nist:complianceAssessmentV2(assessmentType:"cybersecurity"){
      assessmentName
      score
    }
    iso9001: complianceAssessmentV2(assessmentType:"iso9001"){
      assessmentName
      score
    }
  }`
}


// WEBPACK FOOTER //
// ./src/queries/assessment.js